var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"middle"},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"50%","type":"card"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }